import { render, staticRenderFns } from "./AllCase.vue?vue&type=template&id=6ed96571&scoped=true&"
import script from "./AllCase.vue?vue&type=script&lang=js&"
export * from "./AllCase.vue?vue&type=script&lang=js&"
import style0 from "./AllCase.vue?vue&type=style&index=0&id=6ed96571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed96571",
  null
  
)

export default component.exports